import Image from 'next/legacy/image';

import ContactForm from '@components/Homepage/ContactForm';
import { H2, H6 } from '@common/headline';
import { BodyRegular } from '@common/body';
import Icon from '@common/Icons/Icon';

import Map from '@public/img/nhs/map.png';
import MapMobile from '@public/img/nhs/map-mobile.png';

export const HearFromYou = (): JSX.Element => (
  <div className="flex flex-col lg:flex-row">
    <div className="bg-dawn-blue lg:w-1/2" id="hearfromyou">
      <div className="container mx-auto px-6 py-16 lg:p-[75px]">
        <div className="text-center lg:text-left">
          <div className="mb-4 text-blue lg:mb-2">
            <H2>
              Ready to <span className="text-mono-white">transform</span>{' '}
              obesity and type 2 diabetes care?
            </H2>
          </div>
          <div className="mb-7 text-blue">
            <BodyRegular>
              Join forces with Second Nature to bring our life-changing,
              science-backed services to your patients or members. Contact our
              partnerships team today to discuss tailored solutions that can
              transform lives and reshape the future of healthcare.
            </BodyRegular>
          </div>
          <div className="flex flex-row items-center justify-center lg:justify-start">
            <div className="mr-2 stroke-blue">
              <Icon name="pin" />
            </div>
            <div className="text-mono-white">
              <H6>483 Green Lanes, London, N13 4BS</H6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="relative lg:w-1/2">
      <div className="absolute inset-0">
        <Image
          src={Map}
          layout="fill"
          objectFit="cover"
          className="!hidden lg:!block"
          alt="Map"
          loading="lazy"
        />
        <Image
          src={MapMobile}
          layout="fill"
          objectFit="cover"
          className="!block lg:!hidden"
          alt="Map"
          loading="lazy"
        />
      </div>
      <div className="relative z-10 flex min-h-[400px] items-center justify-center p-8 lg:min-h-[600px] lg:p-12">
        <div className="w-full max-w-md">
          <ContactForm />
        </div>
      </div>
    </div>
  </div>
);
